import React from 'react';

export default function IconValuation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.992 22.29 2.162 9.91l5.1-6.2h11.48l5.1 6.18-10.83 12.38-.02.02ZM23.5 9.912H2.143M13.014 22.27 7.264 3.71M13.014 22.27l5.75-18.56"
      />
    </svg>
  );
}
